import { Question, QuestionTypes } from '@playbooks/core/src/interfaces/ActionCard'

export default function isFileQuestion(value: Question): value is Question<[]> {
  return value.type === QuestionTypes.FILE
}
